// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bih_jk","CommentListPlaceholder--Legacy":"ih_b bih_rc bih_wq"};